import { render } from "./BankRecSelectionSummary.vue?vue&type=template&id=ea93596a"
import script from "./BankRecSelectionSummary.vue?vue&type=script&lang=js"
export * from "./BankRecSelectionSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__